exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".option-select[data-v-889c170a]{margin:0 16px 0 0;max-width:9rem}.option-select ::v-deep .v-select__selection--comma[data-v-889c170a]{margin:7px 4px 3px 0;max-width:100%;line-height:1.3}", ""]);

